export default class CurrencyUtilities {
  static currencyFormat(value) {
    if (typeof value === 'string') {
      return value;
    }
    return value.toFixed(2);
  }

  static formatAndValidateCurrencyFromCanvas(value) {
    let formattedCurrency = value;
    if (typeof value !== 'string') {
      return formattedCurrency.toString();
    }
    formattedCurrency = value.replace(/[^0-9.]/g, '');
    formattedCurrency = this.currencyFormat(parseFloat(formattedCurrency));
    return /^-?[\d]*?(.\d{2})?$/.test(formattedCurrency) ? formattedCurrency : undefined;
  }

  static currencyFormatIngredient(value) {
    if (typeof value === 'string') {
      return value;
    }
    return value.toFixed(3);
  }

}
